exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".layout[data-v-3bce6885]{display:flex;flex-direction:column;min-height:100vh;background:#fff}.layout__inner[data-v-3bce6885]{flex-grow:1}", ""]);

